module.exports = "/_next/static/images/app-store-icon-43f89f245a756d2f55ac4bdbafe9866c.png.webp";